import { useMemo } from 'react'

import { CommonTableTemplate } from 'app/common/templates-next/table-template'
import { WarehouseStockItemId } from 'app/common/types/id'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

import {
  warehouseStockTableColumnsArrange,
  warehouseStockTableCellProps,
  warehouseStockTableHeaders,
  WarehouseStockTableDataItem,
  WarehouseStockTableColumn,
} from './tableProps'

import { warehouseStockRenderCell } from './warehouseStockRenderCell'
import { warehouseStockTableRenderHeaderCell } from './warehouseStockTableRenderHeaderCell'
import { WarehouseStock } from 'app/common/types/warehouse/stock'

export const WarehouseStockTable = ({
  createDishMovementLink,
  data,
  loading,
  onRefresh,
}: {
  createDishMovementLink: (dishId: WarehouseStockItemId) => string
  data: WarehouseStock
  loading: boolean
  onRefresh?: () => void
}) => {
  const createDishMovementLinkRef = useCallbackRef(createDishMovementLink)

  const onRefreshRef = useCallbackRef(onRefresh)

  const tableData: Array<WarehouseStockTableDataItem> = useMemo(() => {
    return data.items
      .sort((a, b) => {
        const strA = /^[a-zA-Z]/.test(a.title) ? `0-${a.title}` : `1-${a.title}`
        const strB = /^[a-zA-Z]/.test(b.title) ? `0-${b.title}` : `1-${b.title}`

        return strA.localeCompare(strB, 'ru', { sensitivity: 'base' })
      })
      .map(({ id, title, unit, quantity }) => ({
        id: id as WarehouseStockItemId,
        [WarehouseStockTableColumn.Check]: title,
        [WarehouseStockTableColumn.Title]: title,
        [WarehouseStockTableColumn.Unit]: unit,
        [WarehouseStockTableColumn.Stock]: { quantity, onSuccess: onRefreshRef?.current },
        [WarehouseStockTableColumn.Actions]: {
          createDishMovementLink: createDishMovementLinkRef?.current,
        },
      }))
  }, [data.items, createDishMovementLinkRef, onRefreshRef])

  return (
    <CommonTableTemplate
      data={tableData}
      dataArrange={warehouseStockTableColumnsArrange}
      headerData={warehouseStockTableHeaders}
      headerCellProps={warehouseStockTableCellProps}
      cellProps={warehouseStockTableCellProps}
      renderCell={warehouseStockRenderCell}
      renderHeaderCell={warehouseStockTableRenderHeaderCell}
      loading={loading}
      stickyHeader
    />
  )
}
